// extracted by mini-css-extract-plugin
export default {"section":"section_section__ndK2l","shrink":"section_shrink__dzoFz","inner":"section_inner__LPDH8","innerWide":"section_innerWide__BnB-1","small":"section_small__utCeu"};